import { Link } from "react-router-dom";
import { Home as HomeIcon, Building2, Sun, CheckCircle2, PhoneCall } from "lucide-react";
import { IMG } from "@/lib/images";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { SectionHeading, CtaBand } from "@/components/Shared";

const rows = [
  {
    icon: HomeIcon, title: "RESIDENTIAL", img: IMG.res1,
    lead: "Keep your home's solar system operating at its best.",
    points: [
      { text: "Safe, streak-free cleaning" },
      { text: "Purified water for maximum performance" },
      { text: "Protects your investment and extends system life" },
    ],
  },
  {
    icon: Building2, title: "COMMERCIAL", img: IMG.comm1,
    lead: "Reliable scheduled maintenance for businesses and organizations.",
    points: [
      { text: "Businesses, churches, schools, and offices" },
      { text: "Customized cleaning schedules" },
      { text: "Minimize downtime and maximize efficiency" },
    ],
  },
  {
    icon: Sun, title: "UTILITY SCALE", img: IMG.farm1,
    lead: "Professional cleaning solutions for utility-scale solar farms.",
    points: [
      { text: "Experienced crews and proven processes" },
      { text: "Pure water cleaning available", em: "upon request" },
      { text: "Improve energy production across large arrays" },
    ],
  },
];

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Our Services"
        title={<>Professional Cleaning<br />for Every Solar Installation</>}
        text="We provide expert solar panel cleaning services for residential, commercial, and utility-scale solar installations. Different needs. Same commitment to quality."
      />

      <section className="mx-auto max-w-[1200px] px-5 lg:px-8 py-20">
        <Reveal><SectionHeading title="WHO WE SERVE" /></Reveal>

        <div className="mt-14 space-y-10">
          {rows.map((r, i) => (
            <Reveal key={r.title} delay={i * 0.05}>
              <div className="grid overflow-hidden rounded-2xl bg-white shadow-[0_14px_44px_-22px_rgba(10,35,66,0.35)] md:grid-cols-2">
                <div className="h-60 md:h-auto">
                  <img src={r.img} alt={r.title} className="h-full w-full object-cover" />
                </div>
                <div className="p-8 md:p-10">
                  <div className="flex items-center gap-4">
                    <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#1E5EDB]">
                      <r.icon size={26} className="text-white" />
                    </span>
                    <h3 className="font-display text-2xl font-extrabold text-[#0A2342]">{r.title}</h3>
                  </div>
                  <p className="mt-4 text-[16px] leading-relaxed text-[#5B6B7F]">{r.lead}</p>
                  <ul className="mt-5 space-y-3">
                    {r.points.map((p) => (
                      <li key={p.text} className="flex items-start gap-3 text-[15px] text-[#0A2342]">
                        <CheckCircle2 size={20} className="mt-0.5 shrink-0 text-[#1E5EDB]" />
                        <span>{p.text}{p.em && <span className="font-semibold italic text-[#1E5EDB]"> {p.em}</span>}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBand
        icon={PhoneCall}
        title="Have a Project in Mind?"
        text="We'd love to help you keep your solar system performing at its peak."
      />
    </div>
  );
}
